import constant from "../Constant";


/**
 * 予算書 予算種別選択リストを予算種別名リストに変換する
 * [01, 01, 03] ⇒ ['当初予算', '補正予算', '暫定予算']
 * @param items 予算種別選択一覧
 * @returns 予算種別名一覧
 */
export const getTypeOfBudgetSearchTextList = (items:string[]) => {
    if (!items) {
        return [];
    }
    const list:string[] = [];
    items.map((item:string) => {
        list.push(constant.document.TYPE_OF_BUDGET_SEARCH_ITEMLIST[item]);
    });
    return list;
}

/**
 * 予算書 冊子選択リストを冊子名リストに変換する
 * [0, 2, 3] ⇒ ['一般会計', '政府関連機関', '財務法第２８条等']
 * @param items 冊子選択一覧
 * @returns 冊子名一覧
 */
export const getTypeOfBudgetYosanTextList = (items:number[]) => {
    if (!items) {
        return [];
    }
    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.TYPE_OF_BUDGET_YOSAN_ITEMLIST[item]);
    });
    return list;
}

/**
 * 予算書 所管:一般会計選択リストを所管名リストに変換する
 * @param items 所管選択一覧
 * @returns 所管名一覧
 */
export const getRunningTitleYosanTextList1 = (items:number[]) => {
    if (!items) {
        return [];
    }

    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.RUNNING_TITLE_YOSAN_ITEMLIST1[item]);
    });
    return list;
}

/**
 * 予算書 所管:特別会計選択リストを所管名リストに変換する
 * @param items 所管選択一覧
 * @returns 所管名一覧
 */
export const getRunningTitleYosanTextList2 = (items:number[]) => {
    if (!items) {
        return [];
    }
    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.RUNNING_TITLE_YOSAN_ITEMLIST2[item]);
    });
    return list;
}

/**
 * 決算書 冊子選択リストを冊子名リストに変換する
 * [0, 2, 3] ⇒ ['一般会計', '政府関連機関', '財務法第２８条等']
 * @param items 冊子選択一覧
 * @returns 冊子名一覧
 */
export const getTypeOfBudgetKessanTextList = (items:number[]) => {
    if (!items) {
        return [];
    }
    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.TYPE_OF_BUDGET_KESSAN_ITEMLIST[item]);
    });
    return list;
}

/**
 * 決算書 所管:一般会計選択リストを所管名リストに変換する
 * @param items 所管選択一覧
 * @returns 所管名一覧
 */
export const getRunningTitleKessanTextList1 = (items:number[]) => {
    if (!items) {
        return [];
    }

    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.RUNNING_TITLE_KESSAN_ITEMLIST1[item]);
    });
    return list;
}

/**
 * 決算書 所管:特別会計選択リストを所管名リストに変換する
 * @param items 所管選択一覧
 * @returns 所管名一覧
 */
export const getRunningTitleKessanTextList2 = (items:number[]) => {
    if (!items) {
        return [];
    }
    const list:string[] = [];
    items.map((item:number) => {
        list.push(constant.document.RUNNING_TITLE_KESSAN_ITEMLIST2[item]);
    });
    return list;
}

/**
 * APIレスポンスJSONを年次>PDF>ヒット文章の3次階層に分割する。
 * 
 * 例）
 * [
 * {
 *   'type_of_budget': "当初予算",
 *   'fisical_year_gen': "令和5年",
 *   'source': [
 *       {
 *           'line1': "令和4年度一般会計予算",
 *           'line2': "予算総則",
 *           'line3': "一般会計予算",
 *           'innerHits': [
 *               {
 *                   '_source": {
 *                       data:'テスト０４　１行目　福岡'
 *                       data_highlight:'テスト０４　１行目　<em>福岡</em>'
 *                       pdf_file_name:'202211001000001.pdf'
 *                       pdf_page:'P.1'
 *                   }
 *               }
 *           ]
 *       }
 *   ]
 * }
 * ]
 * @param {} res 
 * @returns 
 */
export const responseParser = function (res:any) {
    let hits = [];  // 年次リスト

    let type_of_budget = "";    // 処理中の
    let display_order = "";     // 
    let fisical_year_gen = "";  // 年度
    let obj:any;
    let lineNo = 0;
    for(var idx in res.hits.hits) {
        
        let hit = res.hits.hits[idx];

        // 年次が変われば1次階層を切り替える。
        if (fisical_year_gen !== hit._source.fisical_year_gen
            || display_order.substr(0, 2) !== hit._source.display_order.substr(0, 2)
        ) {
            
            if (obj) {
                hits.push(obj);
            }

            type_of_budget = hit._source.type_of_budget;
            display_order = hit._source.display_order;
            fisical_year_gen = hit._source.fisical_year_gen;

            obj = {
                'type_of_budget': type_of_budget,
                'display_order': display_order,
                'fisical_year_gen': fisical_year_gen,
                'source': []
            };
        }

        // PDF
        let source = {
            'lineNo': lineNo++,
            'line1': hit._source.line1,
            'line2': hit._source.line2,
            'line3': hit._source.line3,
            'innerHits': []
        };

        // ヒット文章
        let innerHits:any = [];
        for(var i in hit.inner_hits.body.hits.hits) {

            let innerHit = hit.inner_hits.body.hits.hits[i];

            innerHits.push(innerHit);
        }
        source.innerHits = innerHits;

        obj.source.push(source);
    }
    hits.push(obj);

    return hits;
};


/**
 * 以下の年度途中で元号が変わった年度をを置き換える
 * ・平成31年度⇒令和元年度
 * ・昭和64年度⇒平成元年度
 * @param fisical_year_gen 年度
 * @returns 変換後の年度
 */
export const convertFisicalYearGen = (fisical_year_gen:string) => {

    if (fisical_year_gen == "平成31年度") {
        return "令和元年度";
    }
    if (fisical_year_gen == "昭和64年度") {
        return "平成元年度";
    }
    // 変換の必要が無ければそのまま返す
    return fisical_year_gen;
}